const r = {
  name: "Headquarter",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 15V19H7V15H9Z" fill="currentColor"/>
<path d="M17 15V19H15V15H17Z" fill="currentColor"/>
<path d="M9 13H7V9H9V13Z" fill="currentColor"/>
<path d="M13 9V13H11V9H13Z" fill="currentColor"/>
<path d="M17 13H15V9H17V13Z" fill="currentColor"/>
<path d="M7 1H17V5H21V21H23V23H1V21H3V5H7V1ZM13 21H19V7H5V21H11V15H13V21ZM15 3H9V5H15V3Z" fill="currentColor"/>
</svg>
  `
};
export {
  r as Headquarter
};
